import { FlowbiteAccordionTheme, FlowbiteSpinnerTheme, FlowbiteTextInputTheme, FlowbiteTimelineItemTheme, FlowbiteTimelinePointTheme, FlowbiteTimelineTheme, ThemeProps } from "flowbite-react";
import { DeepPartial } from "flowbite-react/dist/types/types";


export function customTimeline(): DeepPartial<FlowbiteTimelineTheme> {
    return {
        "root": {
            "direction": {
              "horizontal": "sm:flex",
              "vertical": "relative border-l border-gray-200 dark:border-gray-700"
            }
          },
          "item": {
            "root": {
              "vertical": "mb-10 ml-6 h-12 last:h-0"
            },
            "content": {
              "root": {
                "base": "",
                "horizontal": "mt-3 sm:pr-8",
                "vertical": ""
              },
              "body": {
                "base": "mb-4 text-base font-normal text-gray-500 dark:text-gray-400"
              },
              "time": {
                "base": "mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
              },
              "title": {
                "base": "pt-[6px] pl-[4px] flex align-center leading-[20px] text-base font-medium text-gray-500"
              }
            },
            "point": {
                "horizontal": "flex items-center",
                "line": "hidden h-[56px] w-full bg-gray-200 dark:bg-gray-700 sm:flex",
                "marker": {
                    "base": {
                        "horizontal": "absolute -left-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-900 dark:bg-gray-700",
                        "vertical": "absolute -left-4 h-8 w-8 rounded-lg border border-white bg-gray-100 dark:border-gray-900 dark:bg-gray-700"
                    },
                    "icon": {
                        "base": "h-4 w-4 text-primary-600 dark:text-cyan-300",
                        "wrapper": "absolute -left-4 flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100  dark:bg-cyan-900 dark:ring-gray-900"
                    }
              },
              "vertical": ""
            }
        }
    }
}
 

export function customTimelineActivePoint(): DeepPartial<FlowbiteTimelinePointTheme> {
    return {
        "horizontal": "flex items-center",
        "line": "hidden h-[56px] w-full bg-gray-200 dark:bg-gray-700 sm:flex",
        "marker": {
            "base": {
                "horizontal": "absolute -left-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-900 dark:bg-gray-700",
                "vertical": "absolute -left-4 h-8 w-8 rounded-lg border border-white bg-gray-100 dark:border-gray-900 dark:bg-gray-700"
            },
            "icon": {
                "base": "h-4 w-4 text-green-600 dark:text-cyan-300",
                "wrapper": "absolute -left-4 flex h-8 w-8 items-center justify-center rounded-lg bg-green-100  dark:bg-cyan-900 dark:ring-gray-900"
            }
        },
        "vertical": ""
    }
}
 
